import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducer(agro_exporter_id, producer_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/query_providers/list_crop_field_certifications/${agro_exporter_id}/fetch_producer/${producer_id}`
    );
  },
  fetchCropFieldCertifications(agro_exporter_id, producer_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/query_providers/list_crop_field_certifications/${agro_exporter_id}/fetch_crop_field_certifications/${producer_id}`
    );
  },
  downloadCfCertificateFile(agro_exporter_id, producer_id, crop_field_certification_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/query_providers/list_crop_field_certifications/${agro_exporter_id}/download_certificate_file/${producer_id}/${crop_field_certification_id}`,
      { responseType: "blob" }
    );
  },

  fetchOrganization(agro_exporter_id, organization_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/query_providers/list_organization_certifications/${agro_exporter_id}/fetch_organization/${organization_id}`
    );
  },
  fetchOrganizationCertifications(agro_exporter_id, organization_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/query_providers/list_organization_certifications/${agro_exporter_id}/fetch_organization_certifications/${organization_id}`
    );
  },
  downloadOrgCertificateFile(agro_exporter_id, organization_id, organization_certification_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/query_providers/list_organization_certifications/${agro_exporter_id}/download_certificate_file/${organization_id}/${organization_certification_id}`,
      { responseType: "blob" }
    );
  },

  fetchPackingHouse(agro_exporter_id, packing_house_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/query_providers/list_packing_house_certifications/${agro_exporter_id}/fetch_packing_house/${packing_house_id}`
    );
  },
  fetchPackingHouseCertifications(agro_exporter_id, packing_house_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/query_providers/list_packing_house_certifications/${agro_exporter_id}/fetch_packing_house_certifications/${packing_house_id}`
    );
  },
  downloadPhCertificateFile(
    agro_exporter_id,
    organization_id,
    packing_house_certification_id
  ) {
    return RequesterV1.get(
      `agro_exporter/certifications/query_providers/list_packing_house_certifications/${agro_exporter_id}/download_certificate_file/${organization_id}/${packing_house_certification_id}`,
      { responseType: "blob" }
    );
  }
};
